var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_588",
    "data-name": "Group 588",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.755,
    height: 38.899,
    viewBox: "0 0 33.755 38.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 33.755,
    height: 38.899,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M23.391,9.371a4.685,4.685,0,1,1,4.687-4.685,4.691,4.691,0,0,1-4.687,4.685m0-8.067a3.382,3.382,0,1,0,3.384,3.383A3.386,3.386,0,0,0,23.391,1.3",
    transform: "translate(5.677 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M18.87,32.492A5.692,5.692,0,1,1,24.563,26.8a5.7,5.7,0,0,1-5.692,5.692m0-10.081A4.389,4.389,0,1,0,23.259,26.8,4.394,4.394,0,0,0,18.87,22.41",
    transform: "translate(4 6.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M18.106,28.447a2.411,2.411,0,1,1,2.411-2.41,2.414,2.414,0,0,1-2.411,2.41m0-3.518a1.107,1.107,0,1,0,1.108,1.108,1.109,1.109,0,0,0-1.108-1.108",
    transform: "translate(4.763 7.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M11.181,25.73a11.181,11.181,0,1,1,11.18-11.18,11.194,11.194,0,0,1-11.18,11.18m0-21.058a9.877,9.877,0,1,0,9.877,9.878,9.89,9.89,0,0,0-9.877-9.878",
    transform: "translate(0 1.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M10.1,20.014a6.544,6.544,0,1,1,6.544-6.542A6.551,6.551,0,0,1,10.1,20.014m0-11.784a5.24,5.24,0,1,0,5.24,5.241A5.246,5.246,0,0,0,10.1,8.23",
    transform: "translate(1.08 2.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M8.73,7.525a.652.652,0,0,1-.652-.652V4.021a.652.652,0,0,1,1.3,0V6.873a.652.652,0,0,1-.652.652",
    transform: "translate(2.452 1.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M6.117,8.225A.654.654,0,0,1,5.551,7.9L4.127,5.429a.652.652,0,0,1,1.129-.652l1.426,2.47a.651.651,0,0,1-.24.89.636.636,0,0,1-.325.087",
    transform: "translate(1.226 1.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M4.2,10.138a.644.644,0,0,1-.326-.087L1.408,8.624A.651.651,0,1,1,2.06,7.5L4.528,8.922A.651.651,0,0,1,4.2,10.138",
    transform: "translate(0.328 2.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M3.5,12.75H.652a.652.652,0,1,1,0-1.3H3.5a.652.652,0,1,1,0,1.3",
    transform: "translate(0 3.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1.735,17.121A.651.651,0,0,1,1.409,15.9L3.878,14.48a.651.651,0,1,1,.652,1.128L2.061,17.033a.644.644,0,0,1-.326.087",
    transform: "translate(0.328 4.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M4.69,20.321a.636.636,0,0,1-.325-.087.651.651,0,0,1-.24-.89l1.426-2.47a.652.652,0,0,1,1.129.652l-1.425,2.47a.654.654,0,0,1-.566.326",
    transform: "translate(1.226 5.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M8.73,21.492a.652.652,0,0,1-.652-.652V17.988a.652.652,0,0,1,1.3,0V20.84a.652.652,0,0,1-.652.652",
    transform: "translate(2.452 5.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M13.1,20.321a.654.654,0,0,1-.566-.326l-1.425-2.47a.652.652,0,0,1,1.129-.652l1.426,2.47a.652.652,0,0,1-.239.89.644.644,0,0,1-.326.087",
    transform: "translate(3.345 5.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M16.3,17.121a.636.636,0,0,1-.325-.087l-2.469-1.426a.651.651,0,1,1,.652-1.128L16.626,15.9a.652.652,0,0,1-.327,1.216",
    transform: "translate(4 4.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M17.471,12.75H14.62a.652.652,0,1,1,0-1.3h2.851a.652.652,0,1,1,0,1.3",
    transform: "translate(4.239 3.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M13.831,10.137a.651.651,0,0,1-.326-1.216L15.974,7.5a.651.651,0,0,1,.652,1.128L14.157,10.05a.644.644,0,0,1-.326.087",
    transform: "translate(4 2.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M11.674,8.225a.636.636,0,0,1-.325-.087.651.651,0,0,1-.24-.89l1.426-2.47a.652.652,0,0,1,1.129.652L12.239,7.9a.654.654,0,0,1-.566.326",
    transform: "translate(3.345 1.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M9.251,15.511a2.891,2.891,0,1,1,2.891-2.891,2.9,2.9,0,0,1-2.891,2.891m0-4.479a1.588,1.588,0,1,0,1.588,1.588,1.59,1.59,0,0,0-1.588-1.588",
    transform: "translate(1.93 2.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M7.011,5.9a.651.651,0,0,1-.149-1.285L25.832.15a.643.643,0,0,1,.783.485.65.65,0,0,1-.486.782L7.16,5.88a.59.59,0,0,1-.15.018",
    transform: "translate(1.93 0.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M21.566,32.779a.758.758,0,0,1-.12-.01.653.653,0,0,1-.523-.76L26.066,4.088a.653.653,0,0,1,1.284.237L22.206,32.246a.654.654,0,0,1-.64.533",
    transform: "translate(6.347 1.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M18.288,31.894a.65.65,0,0,1-.43-.162L2.782,18.479a.653.653,0,0,1,.862-.98L18.718,30.753a.652.652,0,0,1-.43,1.142",
    transform: "translate(0.777 5.262)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.85165cfd50dea1a5af991a7297e70898.svg";
export { ForwardRef as ReactComponent };